<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>鸣野资源管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 查询 -->
    <div class="content">
      <el-form
        inline
        :model="query"
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>

        <el-form-item label="资源状态" label-width="80px">
          <el-select
            v-model="query.state"
            clearable
            placeholder="请选择状态"
            @change="stateClick()"
          >
            <el-option
              v-for="item in statelist"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="来源"
          label-width="80px"
          style="margin-left: -15px"
        >
          <el-select
            v-model="query.origin"
            filterable
            clearable
            @change="stateClick()"
          >
            <el-option
              v-for="item in sourselist"
              :label="item.name"
              :value="item.id"
              :key="item.id"
              placeholder="请选择"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="顾问" label-width="80px">
          <DeptRoleTeacherSelect v-model="query.adviserID" dept="鸣野" placeholder="请选择部门 → 角色 → 老师" @change="datelClick()" />
        </el-form-item>
        <el-form-item label="营销" label-width="80px">
          <DeptRoleTeacherSelect v-model="query.marketID" dept="鸣野" placeholder="请选择部门 → 角色 → 老师" @change="datelClick()" />
        </el-form-item>
        <el-form-item label="学历" label-width="60px">
          <el-select v-model="query.eduBack" clearable filterable placeholder="请选择" @change="selList()">
            <el-option v-for="item in edubacklist" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在地" label-width="70px">
          <el-select v-model="query.province" clearable filterable placeholder="请选择" @change="selList()">
            <el-option v-for="item in provinceList" :label="item.areaName" :value="item.areaName" :key="item.areaID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学生/家长" label-width="80px">
          <el-select v-model="query.studentType" clearable placeholder="请选择" @change="selList()">
            <el-option v-for="item in studentTypeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <div>
          <el-form-item
            label="添加时间"
            label-width="80px"
            style="margin-left: 8px"
          >
            <el-date-picker
              v-model="query.daterange"
              @change="datelClick()"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="赴日时间" label-width="80px">
            <el-select v-model="query.abroadPlan" filterable clearable placeholder="请选择" @change="selList()">
              <el-option label="请选择" value></el-option>
              <el-option v-for="item in planList" :label="item" :value="item" :key="item"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="selList()">查询</el-button>
            <!-- <el-button
              type="success"
              v-if="userIsMarket == false"
              @click="addClick()"
              >新增</el-button
            > -->
            <el-button type="success" @click="exportClick()">导出</el-button>
          </el-form-item>
        </div>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div class="clearfix" slot="header">
          <span>鸣野跟进列表</span>
        </div>
        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width: 100%"
          @sort-change="sortChange"
          @filter-change="filterTag"
          :row-class-name="tableRowClassName"
        >
          <el-table-column prop="inputTime" label="添加时间"></el-table-column>
          <el-table-column prop="realName" label="姓名"></el-table-column>
          <el-table-column prop="wechat" label="微信"></el-table-column>
          <el-table-column prop="eduBack" label="学历"></el-table-column>
          <el-table-column label="学生/家长" :width="100">
            <template slot-scope="scope">
              <el-tag type="primary" v-if="scope.row.studentType == '家长'">家长</el-tag>
              <el-tag type="warning" v-else-if="scope.row.studentType == '学生'">学生</el-tag>
              <span v-else>{{ scope.row.studentType || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="location" label="所在地" :width="150"></el-table-column>
          <el-table-column prop="abroadDate" label="赴日时间" :width="100"></el-table-column>
          <el-table-column prop="applySchoolStu" label="申请学校" :width="150"></el-table-column>
          <el-table-column prop="japanese" label="日语" :width="150"></el-table-column>
          <el-table-column prop="english" label="英语" :width="150"></el-table-column>
          <el-table-column prop="artsScience" label="文理" :width="150"></el-table-column>
          <el-table-column prop="major" label="专业" :width="150"></el-table-column>
          <!--  -->
          <el-table-column prop="intendedCourse" label="意向课程" :width="150"></el-table-column>
          <el-table-column label="营销" min-width="80">
            <template slot-scope="scope">{{ scope.row.myMarketName != null ? scope.row.myMarketName : (scope.row.marketName || '-') }}</template>
          </el-table-column>
          <el-table-column prop="myAdviserName" label="顾问"></el-table-column>
          <el-table-column label="来源">
            <template slot-scope="scope">
              <span :title="scope.row.origin">{{ scope.row.origin }}</span>
              <span :title="scope.row.recName">{{ scope.row.recName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="myStatus" label="状态"></el-table-column>
          <el-table-column label="跟进情况" min-width="140" width="200" class-name="follow-combined-cell">
            <template slot-scope="scope">
              <span class="cell-wrap-pre" :title="scope.row.followSummaryCombined || scope.row.mingyeFollowSummary">{{ scope.row.followSummaryCombined || scope.row.mingyeFollowSummary || '—' }}</span>
            </template>
          </el-table-column>
          <!-- 留学=primary 日语=success 鸣野=warning；留学s=已签约(研究生) 其他=跟进中 无=待分配 -->
          <el-table-column label="跟进状态" :width="150">
            <template slot-scope="scope">
              <OtherDeptFollow :row="scope.row" :show-mingye="false" @show-follow="showFollowDialog" />
            </template>
          </el-table-column>
          <el-table-column label="回访1" width="100">
            <template slot-scope="scope">
              <span class="link-like" @click="showVisitDetail(scope.row, 1)">{{ hasVisit1(scope.row) ? '已回访' : '未回访' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="回访2" width="100">
            <template slot-scope="scope">
              <span class="link-like" @click="showVisitDetail(scope.row, 2)">{{ hasVisit2(scope.row) ? '已回访' : '未回访' }}</span>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button-group v-if="isMarketingOnlyMingye(scope.row) || isNoAdviserMingye(scope.row)">
                <el-tooltip content="查看详情" placement="top">
                  <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-view"
                    @click="showstuid = scope.row.studentID"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button type="info" size="mini" icon="el-icon-user-solid"
                    @click="assignClick(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
              <el-button-group v-else>
                <el-tooltip content="查看详情" placement="top">
                  <el-button type="success" size="mini" icon="el-icon-view"
                    @click="showstuid = scope.row.studentID"></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button type="info" size="mini" icon="el-icon-user-solid"
                    @click="assignClick(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="编辑" placement="top" v-if="canEditMingye(scope.row)">
                  <el-button type="primary" size="mini" icon="el-icon-edit"
                    @click="editClick(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 编辑鸣野资源对话框（与日语编辑逻辑一致：先学生基础字段，再鸣野专有字段） -->
    <el-dialog
      :title="form.studentID > 0 ? '编辑鸣野资源' : '添加鸣野资源'"
      :visible.sync="dialogVisible"
      width="900px"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form')"
      >
        <!-- 与日语一致：添加时间、姓名、性别、资源状态、学历；顾问/营销老师放在最下面 -->
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="添加时间" prop="myInputTime" :rules="[{ required: true, message: '不能为空' }]">
              <el-date-picker v-model="form.myInputTime" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date"
                placeholder="选择时间" style="width: 100%"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="姓名" prop="realName" :rules="[{ required: true, message: '请输入姓名' }]">
              <el-input v-model="form.realName" placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="性别" prop="sex" :rules="[{ required: true, message: '请选择性别' }]">
              <el-radio-group v-model="form.sex">
                <el-radio :label="true">男</el-radio>
                <el-radio :label="false">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="资源状态" prop="state" :rules="[{ required: true, message: '不能为空' }]">
              <el-select v-model="form.state" clearable placeholder="请选择资源状态" filterable style="width: 100%">
                <el-option v-for="item in statelist" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="学历" prop="eduBack" :rules="[{ required: true, message: '不能为空' }]">
              <el-select v-model="form.eduBack" clearable placeholder="请选择学历" filterable style="width: 100%">
                <el-option v-for="item in edubacklist" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="退出费用" prop="exitAmount" v-if="form.state == 'f'">
          <el-input v-model.number="form.exitAmount" type="number" placeholder="请输入数字"></el-input>
        </el-form-item>
        <el-form-item label="退费时间" prop="refundTime"  v-if="form.state == 'f'">
              <el-date-picker v-model="form.refundTime" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date"
                placeholder="选择日期" style="width: 100%"></el-date-picker>
            </el-form-item>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="地区">
              <el-cascader :options="areaList" :props="{ label: 'label', value: 'label' }" v-model="selectedOptions"
                style="width: 100%" clearable></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="微信" prop="wechat">
              <el-input v-model="form.wechat" placeholder="请输入微信"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="QQ" prop="qq">
              <el-input v-model="form.qq" placeholder="请输入QQ"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-alert type="warning" style="position: relative; top: -10px" v-if="form.wechatCheck">{{ form.wechatCheck }}</el-alert>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="日语" prop="japanese">
              <el-select v-model="form.japanese" placeholder="请选择日语水平" filterable clearable style="width: 100%">
                <el-option v-for="item in japlist" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="来源" prop="origin">
              <el-select v-model="form.origin" clearable placeholder="请选择来源" filterable style="width: 100%" @change="changeReouce">
                <el-option v-for="item in sourselist" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="推荐人" prop="recName" v-if="currentOriginName == '留学组推荐' || currentOriginName == '日语组推荐'">
          <el-select v-model="form.recName" placeholder="请选择" filterable clearable style="width: 100%">
            <el-option v-for="item in adviserlist" :label="item.realName" :value="item.realName" :key="item.userID"></el-option>
          </el-select>
        </el-form-item>
        <!-- 来源下一层：抖音=直播/短视频，小红书=账号来源等，数据来自 GetStuParam 的 originParam[].children -->
        <el-form-item :label="currentOriginName == '小红书' ? '小红书' : labelorgin" prop="recName" v-if="ischildren && subOriginOptions.length > 0">
          <el-select v-model="form.recName" placeholder="请选择" filterable clearable style="width: 100%">
            <el-option v-for="item in subOriginOptions" :label="item.name" :value="item.name" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电话" prop="mobile">
          <el-input v-model.number="form.mobile" type="number" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="意向课程" prop="intendedCourse">
              <el-input v-model="form.intendedCourse" placeholder="请输入意向课程"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="学生/家长" prop="studentType">
              <el-select v-model="form.studentType" placeholder="请选择" clearable style="width: 100%">
                <el-option label="学生" value="学生"></el-option>
                <el-option label="家长" value="家长"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="跟进情况" prop="followSummary">
          <el-input v-model="form.followSummary" placeholder="请输入跟进情况"></el-input>
        </el-form-item>

        <!-- 鸣野专有：英语、文理、专业、缴费、学习、升学（申请感受/合格通知书/聊天记录在 VIP/案例 中维护） -->
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="英语" prop="english">
              <el-input v-model="form.english" placeholder="请输入英语水平"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="文理" prop="artsScience">
              <el-select v-model="form.artsScience" placeholder="请选择" clearable style="width: 100%">
                <el-option label="文科" value="文科"></el-option>
                <el-option label="理科" value="理科"></el-option>
                <el-option label="艺术" value="艺术"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 缴费时间/缴费金额/学习课程/开课时间/结课时间 仅在 VIP 列表编辑；跟进列表保留 专业、赴日时间、语言学校 -->
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="专业" prop="major">
              <el-input v-model="form.major" placeholder="请输入专业"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <SelectAbroad ref="selectAbroadEdit" v-on:selabroad="function(str){ form.abroadDate = str; }"></SelectAbroad>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="出身校" prop="schoolName">
              <el-input v-model="form.schoolName" placeholder="请输入出身校"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-form-item label="升学阶段" prop="stage">
          <el-radio-group v-model="form.stage">
            <el-radio :label="1">赴日前</el-radio>
            <el-radio :label="2">升学时</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <template v-if="form.stage == 2">
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="留考成绩" prop="examScore">
                <el-input v-model="form.examScore" placeholder="请输入留考成绩"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="合格时间" prop="qualifiedTime">
                <el-date-picker v-model="form.qualifiedTime" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date"
                  placeholder="选择日期" clearable style="width: 100%"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="合格学校及专业" prop="qualifiedSchools">
                <el-input v-model="form.qualifiedSchools" type="textarea" :rows="2" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="入学学校" prop="enrolledSchool">
                <el-input v-model="form.enrolledSchool" placeholder="请输入入学学校"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="入学专业" prop="enrolledMajor">
                <el-input v-model="form.enrolledMajor" placeholder="请输入入学专业"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>

        <div>
          <el-divider content-position="left" style="padding: 10px 0px">修改顾问/营销老师</el-divider>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="顾问老师" prop="myAdviserID" :rules="[{ required: true, message: '请选择' }]">
                <DeptRoleTeacherSelect v-model="form.myAdviserID" dept="鸣野" placeholder="请选择部门 → 角色 → 老师" />
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="营销老师" prop="myMarketID">
                <DeptRoleTeacherSelect v-model="form.myMarketID" dept="鸣野" placeholder="请选择部门 → 角色 → 老师" />
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 其他部门跟进详情弹窗（统一组件） -->
    <FollowDetailDialog :visible.sync="followDialogVisible" :type="followType" :row="followDialogRow" />
    <!-- 分配弹框（统一组件）：学生鸣野页可分配留学、日语 -->
    <AssignResourceDialog
      :visible.sync="assignDialogVisible"
      :form="assignForm"
      :adviser-list="adviserlist"
      :market-list="marketlist"
      :user-is-admain="userIsAdmain"
      :show-student="true"
      :show-jap="true"
      :show-mingye="false"
      name-label="学生姓名"
      empty-message="请选择分配给留学或日语"
      @success="getList"
    />

    <VisitDetailDialog
      :visible.sync="visitDetailVisible"
      :row="visitDetailRow"
      :which-visit="visitDetailWhich"
      follow-type="mingye"
      @success="getList"
      @closed="onVisitDetailClosed"
    />

    <MingYE :stuid="showstuid" v-on:setzero="showstuid = 0"></MingYE>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import user from "@/plugins/user.js";
// import StudentShow from "@/components/StudentShow";
import MingYE from "@/components/mingye";
import OtherDeptFollow from "@/components/OtherDeptFollow";
import FollowDetailDialog from "@/components/FollowDetailDialog";
import VisitDetailDialog from "@/components/VisitDetailDialog";
import AssignResourceDialog from "@/components/AssignResourceDialog";
import DeptRoleTeacherSelect from "@/components/DeptRoleTeacherSelect.vue";
import SelectAbroad from "@/components/SelectAbroad";
export default {
  name: 'mingye',
  components: {
    MingYE,
    OtherDeptFollow,
    FollowDetailDialog,
    VisitDetailDialog,
    AssignResourceDialog,
    DeptRoleTeacherSelect,
    SelectAbroad,
  },
  data() {
    return {
      userIsAdmain: user.isAdmin(),
      userIsAdviser: user.isAdviser(),
      userIsMarket: user.isMarket(),
      query: {},
      form: {},
      submiting: false,
      loading: false,
      dialogVisible: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage4: 1,
      marketlist: [],
      adviserlist: [],
      sourselist: [], // 来源（树形，含下一层）
      schoollist: [],
      ischildren: false,
      labelorgin: '',
      subOriginOptions: [], // 当前来源的次级选项（如抖音的直播/短视频、小红书的账号来源）
      currentOriginName: '', // 当前选中的来源名称
      statelist: url.getStateData(),
      edubacklist: url.getEduBack(),
      studentTypeList: url.getStudentTypeList(), // 学生/家长
      provinceList: [], // 省份列表
      planList: url.getAbroadYear(), // 赴日时间（与留学计划赴日一致）
      japlist: url.getJapLevelList(), // 日语水平（与日语资源统一）
      areaList: [],
      selectedOptions: [],
      studentList: [],
      showstuid: 0,
      assignDialogVisible: false,
      assignForm: {
        studentID: null,
        realName: '',
        isStudent: false,
        isJap: false,
        isMingye: true,
        resourceTypes: [],
        adviserID: null,
        marketID: null,
        jpAdviserID: null,
        jpMarketID: null,
        myAdviserID: null,
        myMarketID: null
      },
      visitDetailVisible: false,
      visitDetailRow: null,
      visitDetailWhich: 1,
      followDialogVisible: false,
      followDialogLoading: false,
      followType: '',
      followDialogRow: null,
      followData: { list: [] },
      followJapHasCourse: false,
      followDialogTitle: '',
    };
  },
  methods: {
    canEditMingye(row) {
      return user.canEditMingye(row);
    },
    isMarketingOnlyMingye(row) {
      return user.isMarketingOnlyMingye(row);
    },
    isNoAdviserMingye(row) {
      return user.isNoAdviserMingye(row);
    },
    showLimitedOpMingye(row) {
      return user.showLimitedOpMingye(row);
    },
    hasVisit1(row) {
      if (!row) return false;
      const d = row.visit1Date || row.Visit1Date;
      const s = row.visit1Subject || row.Visit1Subject;
      const sum = row.visit1Summary != null ? row.visit1Summary : (row.Visit1Summary != null ? row.Visit1Summary : '');
      return (d != null && d !== '') || (s != null && String(s).trim() !== '') || (sum != null && String(sum).trim() !== '');
    },
    hasVisit2(row) {
      if (!row) return false;
      const d = row.visit2Date || row.Visit2Date;
      const s = row.visit2Subject || row.Visit2Subject;
      const sum = row.visit2Summary != null ? row.visit2Summary : (row.Visit2Summary != null ? row.Visit2Summary : '');
      return (d != null && d !== '') || (s != null && String(s).trim() !== '') || (sum != null && String(sum).trim() !== '');
    },
    showVisitDetail(row, whichVisit) {
      this.visitDetailRow = row;
      this.visitDetailWhich = whichVisit === 2 ? 2 : 1;
      this.visitDetailVisible = true;
    },
    onVisitDetailClosed() {
      this.visitDetailRow = null;
      this.visitDetailWhich = 1;
      this.loading = false;
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.state === "c") {
        return "success-row";
      } else if (row.state === "e") {
        return "info-row";
      }
      return "";
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    sortChange: function (sortColumn) {
      this.query.sort = sortColumn.prop;
      this.query.order = sortColumn.order;
      this.getList();
    },
    filterTag: function (filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      this.getList();
    },
    stateClick: function () {
      this.getList();
    },
    datelClick: function () {
      this.getList();
    },
    // 不再按板块获取，直接获取所有启用用户，营销和顾问下拉共用；统一为 userID/realName 供下拉绑定
    getTeacherList: function () {
      var _this = this;
      var link = url.getStu("getenableusers");
      $.get(link, {}, (data) => {
        var raw = data || [];
        var list = raw.map(function (u) {
          return {
            userID: u.UserID != null ? u.UserID : u.userID,
            realName: (u.RealName != null ? u.RealName : u.realName) || ''
          };
        });
        _this.marketlist = list;
        _this.adviserlist = list;
      });
    },
    getAllOrigin() {
      var _this = this;
      var link = url.getCommon("GetStuParam");
      $.get(link, {}, (data) => {
        _this.sourselist = data.originParam;
      });
    },
    school: function () {
      var _this = this;
      $.get(url.getCommon("getschool"), {}, function (data) {
        _this.schoollist = data || [];
      });
    },
    getAreaList() {
      var _this = this;
      var link = url.getCommon("getareatwo");
      $.getJSON(link, (data) => {
        _this.areaList = data;
      });
    },
    getProvinceList() {
      var _this = this;
      var link = url.getCommon("getareabyname");
      $.get(link, {}, (data) => {
        _this.provinceList = data || [];
      });
    },
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      if (_this.query.daterange) {
        params.start = _this.query.daterange[0];
        params.end = _this.query.daterange[1];
      } else {
        params.start = "";
        params.end = "";
      }
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      var link = url.getMingye("getlist_base");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    addClick: function () {
      this.dialogVisible = true;
      this.form = {
        studentID: null,
        intendedCourse: "",
        studentType: "",
        paymentDate: null,
        paymentAmount: 0,
        abroadDate: null,
        languageSchool: "",
        courseName: "",
        startTime: null,
        endTime: null,
        stage: 1,
        eduBack: "",
        schoolName: "",
        japanese: "",
        english: "",
        examScore: "",
        major: "",
        artsScience: "",
        qualifiedTime: null,
        qualifiedSchools: "",
        enrolledSchool: "",
        enrolledMajor: "",
        feel: "",
        book: "",
        imgList: "",
      };
    },
    editClick: function (row) {
      var _this = this;
      _this.form = Object.assign({}, row);
      _this.form.studentID = row.studentID || row.id;
      _this.form.state = row.myStatus != null ? row.myStatus : row.MyStatus;
      _this.form.stateAbroad = row.stateAbroad != null ? row.stateAbroad : (row.state != null ? row.state : row.State);
      _this.form.myInputTime = row.myInputTime != null ? row.myInputTime : row.inputTime;
      _this.form.inputTime = row.inputTimeRaw != null ? row.inputTimeRaw : row.inputTime;
      _this.form.jpInputTime = row.jpInputTime;
      _this.form.isMingye = true;
      _this.selectedOptions = [];
      if (row.zzProvinceName) _this.selectedOptions.push(row.zzProvinceName);
      if (row.zzCityName) _this.selectedOptions.push(row.zzCityName);
      if (_this.selectedOptions.length === 0 && row.location) _this.selectedOptions = row.location.trim().split(/\s+/).filter(Boolean);
      _this.dialogVisible = true;
      _this.changeReouce(_this.form.origin);
      _this.$nextTick(function () {
        if (_this.$refs.selectAbroadEdit && _this.form.abroadDate) {
          var abroadVal = typeof _this.form.abroadDate === "string" && _this.form.abroadDate.length > 7 ? _this.form.abroadDate.substring(0, 7) : _this.form.abroadDate;
          _this.$refs.selectAbroadEdit.setAbroadTime(abroadVal);
        }
      });
    },
    // 来源变化：若当前来源在 originParam 中配置了 children（如抖音、小红书下一层），则显示次级下拉
    changeReouce(val) {
      if (val == null || val === '') {
        this.ischildren = false;
        this.subOriginOptions = [];
        this.currentOriginName = '';
        this.labelorgin = '';
        return;
      }
      const index = this.sourselist.findIndex(item => item.id == val || item.name === val);
      if (index >= 0) {
        this.currentOriginName = this.sourselist[index].name || '';
        this.labelorgin = this.currentOriginName;
        if (this.sourselist[index].children && this.sourselist[index].children.length > 0) {
          this.ischildren = true;
          this.subOriginOptions = this.sourselist[index].children;
        } else {
          this.ischildren = false;
          this.subOriginOptions = [];
        }
      } else {
        this.ischildren = false;
        this.subOriginOptions = [];
        this.currentOriginName = '';
        this.labelorgin = '';
      }
    },
    submitForm: function (formName) {
      var _this = this;
      this.$refs.form.validate((valid) => {
        if (!valid) return false;
        var info = Object.assign({}, _this.form);
        if (_this.selectedOptions && _this.selectedOptions.length >= 2) {
          info.zzProvinceName = _this.selectedOptions[0];
          info.zzCityName = _this.selectedOptions[1];
        }
        info.recName = _this.form.recName;
        info.myStatus = _this.form.state;
        info.state = _this.form.stateAbroad;
        _this.submiting = true;
        var linkStu = url.getStu("AddOrUpdate_Base");
        $.post(linkStu, info, (resStu) => {
          if (!resStu.status) {
            _this.submiting = false;
            _this.$message({ type: "error", message: resStu.msg || "学生信息保存失败" });
            return;
          }
          var linkMingye = url.getMingye("addorupdate_base");
          $.post(linkMingye, info, (resMy) => {
            _this.submiting = false;
            if (resMy.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({ type: "success", message: resMy.msg || "保存成功" });
            } else {
              _this.$message({ type: "error", message: resMy.msg || "鸣野信息保存失败" });
            }
          });
        });
      });
    },
    exportClick: function () {
      var _this = this;
      var params = _this.query;
      var result = [];
      for (var item in params) {
        if (params[item]) {
          result.push(item + "=" + params[item]);
        }
      }
      var link = url.getMingye("exportmingye") + "?" + result.join("&");
      window.open(link, "_blank");
    },
    showFollowDialog: function(type, row) {
      this.followType = type;
      this.followDialogRow = row && row.studentID != null ? { ...row, id: row.studentID } : (row || {});
      this.followDialogVisible = true;
    },
    viewStudentFollow: function(studentID) {
      if (studentID) window.open('/vue/follow?id=' + studentID, '_blank');
    },
    viewJapFollow: function(studentID) {
      if (studentID) window.open('/vue/japfollow?id=' + studentID, '_blank');
    },
    // 打开鸣野跟进资源页（与日语跟进资源逻辑一致：新标签打开）
    openMingyeFollow: function(studentID) {
      if (studentID) {
        var url = this.$router.resolve({ name: 'mingyefollow', query: { id: studentID } }).href;
        window.open(url, '_blank');
      }
    },
    // 其他部门跟进列：只显示两种——没分配=待分配，分配了=跟进中
    getStateName: function(state) {
      return state ? '跟进中' : '待分配';
    },
    // 分配（由统一组件 AssignResourceDialog 提交）
    assignClick: function(row) {
      if (!row) return;
      var _this = this;
      var currentUserID = user.getInfo() && (user.getInfo().userID != null ? user.getInfo().userID : user.getInfo().Id);
      _this.assignForm = {
        studentID: row.studentID || row.id,
        realName: row.realName || '',
        isStudent: row.isStudent || false,
        isJap: row.isJap || false,
        isMingye: true,
        resourceTypes: [],
        adviserID: row.adviserID || null,
        marketID: row.marketID || null,
        jpAdviserID: row.jpAdviserID || null,
        jpMarketID: _this.userIsAdmain ? (row.jpMarketID || null) : (currentUserID || null),
        myAdviserID: row.myAdviserID || null,
        myMarketID: _this.userIsAdmain ? (row.myMarketID || null) : (currentUserID || null)
      };
      _this.assignDialogVisible = true;
    },
  },
  mounted() {
    this.getAllOrigin();
    this.school();
    this.getAreaList();
    this.getTeacherList();
    this.getProvinceList();
    this.getList();
  },
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.link-like { color: #409EFF; cursor: pointer; }
.link-like:hover { text-decoration: underline; }
.visit-block { margin-bottom: 16px; }
.visit-block .visit-label { font-weight: bold; margin-bottom: 8px; color: #303133; }
.visit-block div { margin-bottom: 4px; }
/* 跟进情况列：自动换行，原+回访1+回访2 各自换行 */
.cell-wrap-pre { white-space: pre-line; word-break: break-word; }
::v-deep .follow-combined-cell .cell { white-space: pre-line !important; word-break: break-word; }
</style>

